// extracted by mini-css-extract-plugin
export var desktopImg = "InfographicsHeroNarrow-module--desktopImg--50b93";
export var imgContainer = "InfographicsHeroNarrow-module--imgContainer--bb044";
export var mobileImage = "InfographicsHeroNarrow-module--mobileImage--ffd7a";